import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import axios from "axios";
import React from "react";
import { baseUrl, mainBaseUrl } from "../../App";

const UpdateProfile = ({ profileInfo, name, mobile }) => {
  const [open, setOpen] = React.useState(false);
  const [updatename, setUpdatename] = React.useState("");
  const [newPass, setNewPass] = React.useState("");
  const [confirmnewPass, setConfirmnewPass] = React.useState("");
  const [oldpassword, setOldpassword] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const updatePhone = () => {
    var config = {
      method: "patch",
      url: `${mainBaseUrl}/users/me`,
      data: {
        mobile: phone,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(handleClose)
      .then(() => profileInfo())
      .catch(function (e) {
        alert(JSON.stringify(e.response.data));
      });
  };

  const updateName = () => {
    var config = {
      method: "patch",
      url: `${mainBaseUrl}/users/me`,
      data: {
        name: updatename,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(handleClose)
      .then(() => profileInfo())
      .catch(function (e) {
        alert(JSON.stringify(e.response.statusText));
      });
  };

  const updatePassword = () => {
    if (newPass === confirmnewPass) {
      var config = {
        method: "patch",
        url: `${mainBaseUrl}/users/me/password`,
        data: {
          oldPassword: oldpassword,
          newPassword: newPass,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "API-Key": baseUrl,
        },
      };

      axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .then(handleClose)
        .then(() => profileInfo())
        .catch(function (e) {
          alert(JSON.stringify(e.response.data));
        });
    } else {
      alert("Password do not match");
    }
  };

  return (
    <div>
      <button onClick={handleClickOpen}>Update Profile</button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Update Profile</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You can update any of these or both
          </DialogContentText>
          <TextField
            margin="dense"
            id="name"
            label="Full Name"
            type="text"
            defaultValue={name}
            variant="outlined"
            onChange={(event) => setUpdatename(event.target.value)}
            fullWidth
          />
          <Button
            onClick={updateName}
            variant="contained"
            style={{
              backgroundColor: "#200e32",
              color: "white",
            }}
          >
            Update Name
          </Button>

          <TextField
            margin="dense"
            id="phone"
            label="Phone Number"
            defaultValue={mobile}
            type="text"
            variant="outlined"
            onChange={(event) => setPhone(event.target.value)}
            fullWidth
          />
          <Button
            onClick={updatePhone}
            variant="contained"
            style={{
              backgroundColor: "#200e32",
              color: "white",
            }}
          >
            Update Phone
          </Button>
          <br />
          <br />
          <br />
          <TextField
            variant="outlined"
            margin="dense"
            id="oldPassword"
            label="Old Password"
            type="text"
            onChange={(event) => setOldpassword(event.target.value)}
            fullWidth
          />
          <TextField
            variant="outlined"
            margin="dense"
            id="newPass"
            label="Password"
            type="text"
            onChange={(event) => setNewPass(event.target.value)}
            fullWidth
          />
          <TextField
            variant="outlined"
            margin="dense"
            id="confirmNewpass"
            label="Confirm Password"
            type="text"
            onChange={(event) => setConfirmnewPass(event.target.value)}
            fullWidth
          />
          <Button
            onClick={updatePassword}
            variant="contained"
            style={{
              backgroundColor: "#200e32",
              color: "white",
            }}
          >
            Update Password
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UpdateProfile;
